import script from "./MainSideView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainSideView.vue?vue&type=script&setup=true&lang=ts"

import "./MainSideView.vue?vue&type=style&index=0&id=551f8da5&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-551f8da5"]])

export default __exports__